import { render, staticRenderFns } from "./UsuarioSenha.vue?vue&type=template&id=d05dfd8a"
import script from "./UsuarioSenha.vue?vue&type=script&lang=js"
export * from "./UsuarioSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports